import * as M from "@discovery/prelude/lib/data/maybe";
import { pushSuggestedSearchEvent } from "@discovery/common-dplus/lib/adobe";
import { SonicImage } from "@discovery/components-luna/lib/components/atoms/image";
import { Link } from "../../../atoms/link";
import { Typography, Tags, HeaderVariants } from "../../../atoms/typography";
import { PlaceholderImage, HeightVariant, } from "../../../atoms/placeholder-image";
import { Icon, Icons } from "../../../atoms/icon";
import { getIsMobile } from "../../../../utils/isMobile";
import * as styles from "./styles.css";
const SecondaryCardCompact = ({ cardData, isSearchWeb, ageConstraint, debouncedSearchTerm, searchResultsLength, premiumPackages, isSearchPage = false, }) => {
    const { image, name, route, descriptionM = M.empty(), category, videoType = M.empty(), seasonNumberM = M.empty(), minimumAgeM = M.empty(), packages, } = cardData;
    const type = M.fromMaybe(videoType, "");
    const seasonId = M.fromMaybe(seasonNumberM, 0);
    const checkVideoType = type ? `?type=${type}` : "";
    const checkSeasonId = seasonId > 0 ? `&seasonId=${seasonId}` : "";
    const description = M.fromMaybe(descriptionM, "");
    const showPlayIcon = !getIsMobile() ? true : false;
    const minimumAge = M.fromMaybe(minimumAgeM, 0);
    const isContentAccessible = ageConstraint && minimumAge >= ageConstraint;
    const sendAnalyticsEvent = (name) => {
        pushSuggestedSearchEvent(debouncedSearchTerm, name, searchResultsLength);
    };
    const isPremium = premiumPackages && premiumPackages.includes(packages);
    return (React.createElement(Link, { href: route + `${checkVideoType}${checkSeasonId}` },
        React.createElement("div", { className: isSearchWeb
                ? styles.secondaryCompactCardContainerWeb
                : styles.secondaryCompactCardContainer },
            React.createElement("div", { className: styles.secondaryCompactCardImage },
                React.createElement(PlaceholderImage, { variant: HeightVariant.Search }),
                image && (React.createElement(React.Fragment, null,
                    showPlayIcon && (React.createElement(Icon, { type: getIsMobile() ? Icons.SearchPlayIcon : Icons.HoverPlayIcon, className: styles.searchPlay, color: "black" })),
                    isContentAccessible && (React.createElement(Icon, { type: Icons.Plus18Tag, className: styles.ageConstraints })),
                    isPremium && (React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: styles.premiumIcon })),
                    React.createElement(SonicImage, { image: image, imageSizes: {
                            default: [100, "vw"],
                            maxWidthMediaQueries: [
                                [699, "px", 120, "px"],
                                [1023, "px", 140, "px"],
                                [1439, "px", 180, "px"],
                                [2559, "px", 200, "px"],
                            ],
                        }, extraImageWidths: [340, 400], className: styles.secondaryCardCompactImage, fallbackImageSize: { width: 260 }, alt: "" })))),
            React.createElement("div", { className: styles.compactCardDescription },
                React.createElement("div", { className: styles.description, onClick: () => category && sendAnalyticsEvent(name) },
                    React.createElement(Typography, { classNameM: M.of(styles.descriptionHead), variant: HeaderVariants.subHeadOne, tag: Tags.span },
                        React.createElement(React.Fragment, null, name)),
                    React.createElement("div", { className: styles.categories }, isSearchPage ? (React.createElement(Typography, { classNameM: M.of(styles.categoryText), variant: HeaderVariants.subHeadTwo, tag: Tags.h2 },
                        React.createElement(React.Fragment, null, category))) : (React.createElement(Typography, { classNameM: M.of(styles.categoryText), variant: HeaderVariants.subHeadTwo, tag: Tags.h2 },
                        React.createElement(React.Fragment, null, description)))))))));
};
export default SecondaryCardCompact;

